/* eslint-disable @typescript-eslint/no-explicit-any */
import { PartiuClient } from "@partiu-vantagens/partiu-sdk";
import axios from 'axios';

export const baseUrl = localStorage.getItem('REACT_APP_API_URL') || process.env.REACT_APP_API_URL;

export const partiuClient: any = new PartiuClient(false);

export function isAuthenticated() {
  try {
    const token = localStorage.getItem('token');
    if (!token) return false;

    return !!(
      axiosInstanceV2.defaults.headers.common['Authorization'] &&
      axiosInstance.defaults.headers.common['Authorization']
    );
  } catch {
    return false;
  }
}

function validateStatus(status: number): boolean {
  if (status === 401) {
    setAccessToken(null);
    localStorage.removeItem('token');
    //window.location.reload();
  }
  return status < 400;
}

export function setAccessToken(token: string | null, tokenExpirationDate?: string | null, agreementId?: string | null) {
  if (token === null || (tokenExpirationDate && new Date(tokenExpirationDate) < new Date())) {
    axiosInstance.defaults.headers.common['Authorization'] = null;
    axiosInstanceV2.defaults.headers.common['Authorization'] = null;
    axiosInstanceV3.defaults.headers.common['Authorization'] = null;
    localStorage.removeItem('token');
    localStorage.removeItem('tokenExpirationDate');

    return;
  }
  axiosInstance.defaults.headers.common['Authorization'] = `TOKEN ${token}`;
  axiosInstanceV2.defaults.headers.common['Authorization'] = `TOKEN ${token}`;
  axiosInstanceV3.defaults.headers.common['Authorization'] = `TOKEN ${token}`;

  localStorage.setItem('token', token);

  if (tokenExpirationDate) localStorage.setItem('tokenExpirationDate', tokenExpirationDate);

  if (agreementId) {
    axiosInstance.defaults.headers.common['x-agreement-id'] = agreementId;
    axiosInstanceV2.defaults.headers.common['x-agreement-id'] = agreementId;
    axiosInstanceV3.defaults.headers.common['x-agreement-id'] = agreementId;
    localStorage.setItem('agreementId', agreementId);
  }
}

function configRequest(config: any) {
  const agreementId = localStorage.getItem('agreementId');
  if (agreementId) {
    config.headers['x-agreement-id'] = agreementId;
  }

  return config;
}

partiuClient.axiosInstance.interceptors.request.use(configRequest);


export const axiosInstanceProd = axios.create({
  baseURL: 'https://api.edge.partiu.com.br/api' + '/v1',
  validateStatus,
});

export const axiosInstance = axios.create({
  baseURL: baseUrl + '/v1',
  validateStatus,
});

export const axiosInstanceV2 = axios.create({
  baseURL: baseUrl + '/v2',
  validateStatus,
});

export const axiosInstanceV3 = axios.create({
  baseURL: baseUrl + '/v3',
  validateStatus,
});

axiosInstance.interceptors.request.use(configRequest);
axiosInstanceV2.interceptors.request.use(configRequest);
axiosInstanceV3.interceptors.request.use(configRequest);

const token = localStorage.getItem('token');
const agreementId = localStorage.getItem('agreementId');
const tokenExpirationDate = localStorage.getItem('tokenExpirationDate');

if (token) setAccessToken(token, tokenExpirationDate, agreementId);
